import { Container, Typography } from '@material-ui/core'
import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useDMEStore } from '../../store'
import useStyles from './styles'
import PhysicianSearchForm from '../../forms/PhysicianSearchForm'
import { UI } from '../../../global'
import CustomerInformationView from '../CustomerInformationView'
import { SEARCH_PHYSICIAN_PATH } from '../../constants'
import PhysicianResultView from '../PhysicianResultView'
import CheckoutJourneyStepsWidget from '../../widgets/CheckoutJourneyStepsWidget'
import CheckoutJourneyWrapperWidget from '../../widgets/CheckoutJourneyWrapperWidget'
import { configureView } from '../../utils/ViewConfiguration'

const PhysicianSearchView: UI.ViewComponent<UI.LifeCycle> = observer(
  ({ onComponentDidMount }) => {
    const store = useDMEStore()
    const classes = useStyles()

    const navigateToResults = () => {
      PhysicianResultView.navigate()
    }

    if (!store.user.present) {
      CustomerInformationView.navigate()
      return null
    }

    useEffect(() => {
      onComponentDidMount()
    }, [])

    return (
      <Container className={classes.viewContainer}>
        <CheckoutJourneyWrapperWidget>
          <CheckoutJourneyStepsWidget
            currentPath={`/${SEARCH_PHYSICIAN_PATH.split('/').pop()}`}
          />
          <Typography
            gutterBottom
            className={classes.disclaimer}
            variant="body1"
          >
            To make it easier for you, we can send a prescription request
            directly to your pregnancy care provider.
          </Typography>
          <PhysicianSearchForm nextAction={navigateToResults} />
        </CheckoutJourneyWrapperWidget>
      </Container>
    )
  }
)

export default configureView(PhysicianSearchView)({
  pathname: SEARCH_PHYSICIAN_PATH,
})
